// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { combineEpics } from 'redux-observable';

import { getCartEpic } from './epics/getCartEpic';
import { getHomeEpic } from './epics/getHomeEpic';
import { getLabInformationEpic } from './epics/getLabInformationEpic';
import { getLabReviewsEpic } from './epics/getLabReviewsEpic';
import { getLabRelatedEpic } from './epics/getLabRelatedEpic';
import { buyLabEpic } from './epics/buyLabEpic';
import { endLabEpic } from './epics/endLabEpic';

import { getChallengeInformationEpic } from './epics/getChallengeInformationEpic';
import { getChallengeReviewsEpic } from './epics/getChallengeReviewsEpic';
import { getChallengeRelatedEpic } from './epics/getChallengeRelatedEpic';
import { buyChallengeEpic } from './epics/buyChallengeEpic';
import { endChallengeEpic } from './epics/endChallengeEpic';
import { getExamInformationEpic } from './epics/getExamInformationEpic';
import { buyExamEpic } from './epics/buyExamEpic';
import { addOnlineCourseToCartEpic } from './epics/addOnlineCourseToCartEpic'
import { removeOnlineCourseFromCartEpic } from './epics/removeOnlineCourseFromCartEpic'
import { getOnlineCourseFeedbackEpic } from './epics/getOnlineCourseFeedbackEpic';
import { getOnlineCourseRelatedEpic } from './epics/getOnlineCourseRelatedEpic';
import { postOnlineCourseFeedbackEpic } from './epics/postOnlineCourseFeedbackEpic';
import { postLabReviewsEpic } from './epics/postLabReviewsEpic';
import { postChallengeReviewsEpic } from './epics/postChallengeReviewsEpic';
import { postOnlineCourseChaptersProgressEpic } from './epics/postOnlineCourseChaptersProgressEpic';
import { postJoinOrganizationEpic } from './epics/postJoinOrganizationEpic';
import { updateViewHistoryEpic } from './epics/updateViewHistoryEpic';
import sendVisitedLabEpic from './epics/sendVisitedLabEpic';
import sendVisitedChallengeEpic from './epics/sendVisitedChallengeEpic';
import Notifications from './epics/notifications';
import OnlineCourseEpic from './epics/onlineCourse';
import SupportEpic from './epics/support';
import SendActiveEpic from './epics/sendActiveEpic';
import SearchEpic from './epics/search';
import WorkshopEpic from './epics/workshop';
import IltCourseEpic from './epics/iltCourse';
import { createFavoritesEpic } from './epics/createFavoritesEpic';
import { deleteFavoritesEpic } from './epics/deleteFavoritesEpic';

export const rootEpic = combineEpics(
  ...Notifications,
  ...OnlineCourseEpic,
  ...SearchEpic,
  ...WorkshopEpic,
  ...SupportEpic,
  ...IltCourseEpic,
  addOnlineCourseToCartEpic,
  createFavoritesEpic,
  deleteFavoritesEpic,
  removeOnlineCourseFromCartEpic,
  getOnlineCourseFeedbackEpic,
  postOnlineCourseFeedbackEpic,
  getOnlineCourseRelatedEpic,
  updateViewHistoryEpic,
  getCartEpic,
  getHomeEpic,
  getLabInformationEpic,
  getLabReviewsEpic,
  getLabRelatedEpic,
  buyLabEpic,
  endLabEpic,
  getChallengeInformationEpic,
  getChallengeReviewsEpic,
  getChallengeRelatedEpic,
  buyChallengeEpic,
  endChallengeEpic,
  getExamInformationEpic,
  buyExamEpic,
  postOnlineCourseChaptersProgressEpic,
  postLabReviewsEpic,
  postChallengeReviewsEpic,
  postJoinOrganizationEpic,
  sendVisitedLabEpic,
  sendVisitedChallengeEpic,
  SendActiveEpic,
);
